'use strict';

import { getVueTemplate } from '../../../_imports/utils/utils.common.js';
import BaseVueComponent from "../../../_imports/shared/base-vue-component.vue.common.js";

export default {
    template: getVueTemplate('series-pagination'),
    mixins: [
        BaseVueComponent,
    ],
    props: {
        displayPreviousArrow: {
            type: Boolean,
            default: false
        },
        displayNextArrow: {
            type: Boolean,
            default: false
        },
        previousResourceThumbnailUrl: {
            type: String,
            required: false,
        },
        nextResourceThumbnailUrl: {
            type: String,
            required: false,
        }
    },
    computed: {
        paginationButtons() {
            return [
                {
                    direction: 'previous',
                    isVisible: this.displayPreviousArrow
                },
                {
                    direction: 'next',
                    isVisible: this.displayNextArrow
                }
            ];
        },
    },
    methods: {
        onPaginationClick(direction) {
            this.$emit('paginationClick', direction);
        },
        getThumbnailUrlBasedOnDirection(direction) {
            switch(direction) {
                case 'previous':
                    return this.previousResourceThumbnailUrl;
                case 'next':
                    return this.nextResourceThumbnailUrl;
                default:
                    return null;
            }
        },
        hasPreviewThumbnail(direction) {
            return this.getThumbnailUrlBasedOnDirection(direction) !== null;
        }
    }
};